module.exports = __webpack_public_path__ + "img/9.a76980b7.webp";